import React from 'react';

import Chip from '@mui/material/Chip';

import { palette, shape } from '@app/theme';

import { getScoreLevel } from '../analysisReport.utilities';


const SCORE_CHIP_COLORS = {
  success: { color: palette.success.main, borderColor: palette.success.main, backgroundColor: palette.success.light },
  warning: { color: palette.warning.main, borderColor: palette.warning.main, backgroundColor: palette.warning.light },
  error:   { color: palette.error.main,   borderColor: palette.error.main,   backgroundColor: palette.error.light   },
} as const;

export interface ScoreChipProperties {
  score: number;
  maxScore: number;
  /**
  Label shown inside the chip. Defaults to `score/maxScore`.
  */
  label?: string;
  /**
  Chip height in px. Defaults to 28.
  */
  height?: number;
  /**
  Font size in px. Defaults to 13.
  */
  fontSize?: number;
  /**
  Horizontal label padding (MUI px unit). Defaults to 1.5.
  */
  labelPx?: number;
  /**
  Whether to render a colored border. Defaults to true.
  */
  showBorder?: boolean;
  dataTest?: string;
}

export const ScoreChip: React.FC<ScoreChipProperties> = ({
  score,
  maxScore,
  label,
  height = 28,
  fontSize = 13,
  labelPx = 1.5,
  showBorder = true,
  dataTest,
}) => {
  const level = getScoreLevel(score, maxScore);
  const colors = SCORE_CHIP_COLORS[level];
  const chipLabel = label ?? `${score}/${maxScore}`;

  return (
    <Chip
      label={chipLabel}
      size='small'
      data-testid={dataTest}
      sx={{
        fontFamily: '"JetBrains Mono", monospace',
        fontSize,
        fontWeight: 600,
        height,
        borderRadius: `${shape.borderRadius}px`,
        ...(showBorder && { border: `1.5px solid ${colors.borderColor}` }),
        color: colors.color,
        backgroundColor: colors.backgroundColor,
        '& .MuiChip-label': { px: labelPx },
      }}
    />
  );
};
